import { INIT_CLIENT, INIT_CLIENT_SUCCESS } from "../../constants/ActionTypes";

const INIT_STATE = {
  client: null,
  loading: false,
  clientReady: false,
};

/**
 * shopify reducer
 * @param state
 * @param action
 * @returns {{checkout}|{checkout: {}}}
 */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_CLIENT: {
      return {
        ...state,
        loading: true,
        clientReady: false,
      };
    }

    case INIT_CLIENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        client: action.payload,
        clientReady: true,
      };
    }
    default:
      return state;
  }
};
